<template>
    <div class="inner-container">
        <div class="col-left">
            <div class="title-container">
                <h2> Email or text this provider’s information. </h2>
                <h6>Message and data rates may apply. </h6>
            </div>
            <div class="cta">
                <div class="d-flex">
                    <div class="icon-container">
                        <img src="/wp-content/themes/bpa-health/dist/images/icons/icon-provider.svg">
                    </div>
                    <div class="info">
                        <label>Provider Name</label>
                        <span>{{ provider.PROVIDER_FIRST_NAME }} {{ provider.Provdier_Last_Name }}</span>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="icon-container">
                        <img src="/wp-content/themes/bpa-health/dist/images/icons/icon-location.svg">
                    </div>
                    <div class="info">
                        <label>Address</label>
                        <span>{{ provider.Address }} {{ provider.City }}, {{ provider.State }} {{ provider.Zip }}</span>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="icon-container">
                        <img src="/wp-content/themes/bpa-health/dist/images/icons/icon-phone.svg">
                    </div>
                    <div class="info">
                        <label>Phone</label>
                        <span>{{ provider.Phone }}</span>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="icon-container">
                        <img src="/wp-content/themes/bpa-health/dist/images/icons/icon-time.svg">
                    </div>
                    <div class="info">
                        <label>Hours</label>
                        <span>{{ provider.business_hours }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-right">
            <div class="card">
                <div class="form-container">
                    <div class="alert" v-if="success">Information has been successfully send.</div>
                    <form name="request-info" class="request-form" @submit.prevent="submit">
                        <div class="form-group">
                            <label>Email</label>
                            <input class="" id="name" placeholder="Email" type="email" v-model="form.email">
                            <p class="error" v-if="error.email">{{ error.email }}</p>
                        </div>

                        <div class="form-group">
                            <label>Phone</label>
                            <input class="" id="name" placeholder="(123)-456-7890" type="text" v-model="form.phone">
                            <p class="error" v-if="error.phone">{{ error.phone }}</p>
                        </div>

                        <div class="recaptcha-container">
                            <RecaptchaV2 @load-callback="handleLoadCallback" @widget-id="handleWidgetId" ref="recaptcha" />
                        </div>
                        <p class="error" v-if="error.captcha">{{ error.captcha }}</p>
                        <div class="btn-container">
                            <button type="submit" class="btn btn-primary"> Submit </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { RecaptchaV2, useRecaptcha } from "vue3-recaptcha-v2"

export default {
    props: {
        provider: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            success: false,
            form: {
                email: '',
                phone: '',
                captcha: '',
                data_ids: []
            },
            error: {
                email: null,
                phone: null,
                captcha: null
            }
        }
    },
    components: { RecaptchaV2 },
    computed: {
        formData () {
            return this.form
        },
    },
    methods: {
        handleWidgetId ( widgetId ) {
            useRecaptcha( widgetId )
        },
        handleSuccess () { },
        handleLoadCallback ( captcha ) {
            this.form.captcha = captcha
        },
        async submit () {
            this.error = {
                email: null,
                phone: null,
                captcha: null
            }
            this.success = false
            this.form.data_ids = []
            this.form.data_ids.push( this.provider.data_id )

            const form = this.formData

            const res = await axios.post( `/wp-json/bpa/v1/providers/send-contact-information`, form )
                .catch( ( error ) => {
                    if ( 'rest_invalid_param' === error.response.data.code ) {
                        if ( error.response.data.data.details.email ) {
                            this.error.email = error.response.data.data.details.email.message
                        }

                        if ( error.response.data.data.details.phone ) {
                            this.error.phone = error.response.data.data.details.phone.message
                        }

                        if ( error.response.data.data.details.captcha ) {
                            this.error.captcha = error.response.data.data.details.captcha.message
                        }

                        if ( error.response.data.data.params?.email ) {
                            this.error.email = 'The field is required'
                        }

                        if ( error.response.data.data.params?.phone ) {
                            this.error.phone = 'The field is required'
                        }

                        if ( error.response.data.data.params?.captcha ) {
                            this.error.captcha = 'The field is required'
                        }
                    }
                } )

            if ( res?.success ) {
                this.success = true
                window.grecaptcha.reset()
            }
        }
    },
    mounted () {
    }
}
</script>

<style lang="scss" scoped>
@import "../../sass/variables";
@import "../../sass/mixins";

.inner-container {
    display: flex;
    gap: 140px;
    align-items: center;
    padding-left: 40px;

    @include xl {
        flex-direction: column;
        padding-left: 0;
    }

    @include lg {
        gap: 32px;
    }

    &>div {
        flex: 1;
    }

    .col-right {
        width: 100%;
    }

    .col-left {
        display: grid;

        .title-container {
            position: relative;
            padding-bottom: 45px;

            &::after {
                position: absolute;
                bottom: 0;
                left: 0;
                background-color: #0B3148;
                height: 2px;
                width: 100%;
                content: "";
            }

            h2 {
                font-size: 32px;
                font-family: "Paralucent Demi";

                @include xl {
                    font-size: 26px;
                }
            }

            h6 {
                margin-top: 20px;
                margin-bottom: 0;
                font-style: italic;
            }
        }

        .cta {
            padding-top: 45px;
            display: grid;
            grid-template-columns: 1fr 1fr;
            column-gap: 32px;
            row-gap: 16px;

            @include md {
                grid-template-columns: 1fr;
            }

            .d-flex {
                display: flex;
                gap: 8px;
                justify-content: flex-start;
                align-items: flex-start;

                .info {
                    display: grid;
                    gap: 8px;

                    label {
                        color: #0B3148;
                        line-height: 1;
                        font-family: "Paralucent Demi";
                    }

                    span {
                        font-size: 16px;
                        line-height: 1.1;
                    }
                }
            }
        }
    }

    .card {
        background-color: $colors-white;
        padding: 55px 85px;
        border-radius: 10px;

        @include xl {
            padding: 32px;
        }

        .request-form {
            display: flex;
            flex-direction: column;
            gap: 24px;

            .form-group {
                gap: 8px;
            }

            .btn-container {
                margin-top: 18px;

                button {
                    cursor: pointer;
                }
            }
        }
    }

    .error {
        font-size: 14px;
        color: red;
    }

    .alert {
        font-size: 14px;
        background: green;
        color: white;
        padding: 5px 10px;
        border-radius: 5px;
        margin-bottom: 8px;
    }
}
</style>